import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import async from 'async';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { AppTheme } from './styles/AppTheme';
import { Header } from './components/Header';
import { Login } from './screens/Login';
import { NotFound } from './screens/NotFound';
import { Terms } from './screens/Terms';
import { Privacy } from './screens/Privacy';
import { Home } from './screens/Home';
import { Admin } from './screens/Admin';
import { Places } from './screens/Places';
import { Users } from './screens/Users';
import { Cams } from './screens/Cams';
import { ClientPlaces } from './screens/ClientPlaces';
import { Reports } from './screens/Reports';
import { ClientPlacesDetails } from './screens/ClientPlace/ClientPlacesDetails';
import { ClientPlaceCamsDetails } from './screens/ClientPlaceCamsDetails';

import { Controller } from './common/Controller';
import { ApiHelperV2 } from './common/helpers/ApiHelperV2';
import { UiHelper } from './common/helpers/UiHelper';
import { Helper } from './common/helpers/Helper'
import { AppConfig } from './AppConfig';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: AppTheme.primaryColor
    },
    secondary: {
      main: AppTheme.secondaryColor
    }
  },
  typography: {
    fontFamily: [
      'Quicksand',
      'sans-serif'
    ].join(',')
  }
});

const ProtectedRoute = (props) => {
  const user = Controller.get().userMgrV2().getloggedInUser();
  if (user) {
    if (props.appUser) {
      return props.checkPermsAndNavigate(props)
    }
    Controller.get().userMgrV2().setloggedInUserLocal(user).then((result) => {
      //console.log('setloggedInUserLocal', result)
      props.setAppUser();
    }).catch((error) => {
      console.log('Fetch user failure', error);
      Controller.get().userMgrV2().signOut()
      props.setAppUser();
    });
    return UiHelper.componentLoadingView()
  } else {
    return <Redirect to='/login' />
  }
}

const PublicRoute = (props) => {
  const link = Controller.get().userMgrV2().getUserHome()
  if (Controller.get().userMgrV2().getloggedInUser()) {
    if (props && props.path === '/login') {
      return <Redirect to={link} />
    }
  }
  return <Route {...props} />
}

class App extends Component {

  constructor(props) {
    //console.log('App::constructor')
    super(props);
    this.state = {
      fetchState: ApiHelperV2.State.LOADING,
      appUser: null
    };
  }

  componentDidMount() {
    //console.log('componentDidMount::App')
    this.setup()
  }

  setup() {
    async.parallel(
      [
        function (callback) {
          ApiHelperV2.publicApiCall(
            { method: 'GET', endPoint: ApiHelperV2.makeUrlPath(['setup']) }, callback)
        }
      ],
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }
        const data = results[0];
        if (data) {
          //console.log("SystemSetupService OK:", data);
          if (data.allowLocal === true) {
            AppConfig.localAuth = data.allowLocal
          }
          if (data.camLiveTab !== undefined ) {
            AppConfig.camLiveTab = data.camLiveTab
          }
          if (data.navbarTitle !== undefined) {
            AppConfig.navbarTitle = data.navbarTitle
          }
          if (data.allCamViewNumberOfColumns !== undefined) {
            AppConfig.allCamViewNumberOfColumns = data.allCamViewNumberOfColumns
          }
          if (data.showAutoUpdateToggle !== undefined) {
            AppConfig.showAutoUpdateToggle = data.showAutoUpdateToggle
          }
          if (data.zoomFeature !== undefined) {
            AppConfig.zoomFeature = data.zoomFeature
          }
          if (data.eventNotificationSound !== undefined) {
            AppConfig.eventNotificationSound = data.eventNotificationSound
          }
          this.setState({
            fetchState: ApiHelperV2.State.READY
          });
        }
      }.bind(this))
  }

  checkPermsAndNavigate = (path, props) => {
    if (Controller.get().userMgrV2().checkUserPermission(path)) {
      if (path === '/') {
        return <Redirect to={Controller.get().userMgrV2().getUserHome()} />
      } else {
        return <Route {...props} />
      }
    } else {
      return UiHelper.getErrorMsg()
    }
  }

  setAppUser = () => {
    this.setState({
      appUser: Controller.get().userMgrV2().getUser(),
    })
  }

  getProtectedRoute(path, component) {
    return (
      <ProtectedRoute
        setAppUser={this.setAppUser}
        appUser={this.state.appUser}
        checkPermsAndNavigate={(props) => this.checkPermsAndNavigate(path, props)}
        exact
        path={path}
        component={component}
      />
    );
  }

  render() {
    if (this.state.fetchState === ApiHelperV2.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelperV2.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }


  readyView() {
    return (
      <Router>
        <MuiThemeProvider theme={theme}>
          <Route path={'/'} component={({ location, history }) => {
            return (
              <div className={css(Styles.page)}>
                {this.state.appUser &&
                  <Header
                    className={css(Styles.header)}
                    currentUser={this.state.appUser}
                    onDashboardClick={() => this.onDashboardClick()}
                    onLogoutClick={() => this.onLogoutClick()} />
                }

                <div className={css(Styles.content)}>
                  {this.renderRoute(history)}
                </div>

                {/* <Footer className={css(Styles.footer)} /> */}

              </div>
            )
          }} />
        </MuiThemeProvider>
      </Router>
    );
  }

  renderRoute(history) {
    Controller.get().setNavigator(history); //TODO should this be given here?
    return (
      <Switch>
        {/* <Route exact path={'/login'} component={Login} /> */}
        <PublicRoute exact path={'/login'} component={Login} />

        <Route exact path={'/terms'} component={Terms} />
        <Route exact path={'/privacy'} component={Privacy} />

        {this.getProtectedRoute('/admin', Admin)}
        {this.getProtectedRoute('/admin/orgs/:id/places', Places)}
        {this.getProtectedRoute('/admin/orgs/:id/users', Users)}
        {this.getProtectedRoute('/admin/places/:id/cams', Cams)}

        {this.getProtectedRoute('/')}
        {this.getProtectedRoute('/places', ClientPlaces)}
        {this.getProtectedRoute('/reports/:id', Reports)}
        {this.getProtectedRoute('/places/:id', ClientPlacesDetails)}
        {this.getProtectedRoute('/places/:id/cams', ClientPlaceCamsDetails)}

        <Route component={NotFound} />
      </Switch>
    )
  }

  onLogoutClick() {
    //console.log('onLogoutClick');
    if (AppConfig.localAuth) {
      Controller.get().userMgrV2().signOut()
    } else {
      //TODO: firebase logout
    }
    this.setState({
      appUser: null
    })
  }

  onDashboardClick() {
    this.props.history.push('/admin');
  }
}

const Styles = StyleSheet.create({
  page: {
    //height: '100%'
  },
  header: {
    flex: '0 0 auto'
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '100vh',
    overflowX: 'hidden'
    /*display: 'flex',
    justifyContent: 'center',
    paddingTop: 120, // for header
    minHeight: 500, // TODO
    overflowX: 'hidden'*/
  },
  footer: {
    flex: '0 0 auto'
  }
})

export default App;



// WEBPACK FOOTER //
// ./src/App.js